import React, { useEffect, useState } from 'react';
import { TrendingUp, Calendar, CheckCircle, Clock } from 'lucide-react';
import { buildApiUrl } from '../../utils/apiSetup';

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('access_token')}`,
});

const MyIncrement = ({ employeeId }) => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadStatus = async () => {
      if (!employeeId) return;
      try {
        const response = await fetch(buildApiUrl(`/api/v1/increments/employee/${employeeId}/status`), { headers: getAuthHeaders() });
        if (response.ok) {
          setStatus(await response.json());
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    loadStatus();
  }, [employeeId]);

  if (loading) return <div className="text-sm text-gray-500">Loading your increment status…</div>;

  return (
    <div className="space-y-6">
      <div className="rounded-xl border border-gray-100 bg-white p-6 shadow-sm">
        <div className="flex items-center mb-4">
          <TrendingUp className="mr-2 h-5 w-5 text-blue-600" />
          <h2 className="text-xl font-semibold text-gray-900">My Increment</h2>
        </div>
        {status ? (
          <div className="grid gap-4 md:grid-cols-3">
            <div className="rounded-lg border border-gray-100 bg-gray-50 p-4">
              <p className="text-sm text-gray-500">Current status</p>
              <p className="text-lg font-semibold text-gray-900">{status.status}</p>
            </div>
            <div className="rounded-lg border border-gray-100 bg-gray-50 p-4">
              <p className="text-sm text-gray-500">Eligible on</p>
              <p className="text-lg font-semibold text-gray-900">{status.eligible_date}</p>
            </div>
            <div className="rounded-lg border border-gray-100 bg-gray-50 p-4">
              <p className="text-sm text-gray-500">Current basic</p>
              <p className="text-lg font-semibold text-gray-900">₹{Number(status.current_basic || 0).toLocaleString('en-IN')}</p>
            </div>
          </div>
        ) : (
          <p className="text-sm text-gray-500">No increment data available yet.</p>
        )}
      </div>

      <div className="rounded-xl border border-gray-100 bg-white p-6 shadow-sm">
        <div className="flex items-center mb-4">
          <Calendar className="mr-2 h-5 w-5 text-gray-600" />
          <h3 className="text-lg font-semibold text-gray-900">Eligibility summary</h3>
        </div>
        <div className="space-y-3">
          <div className="flex items-center justify-between rounded-lg border border-gray-100 bg-gray-50 px-4 py-3">
            <span className="text-sm text-gray-600">Days served</span>
            <span className="font-medium text-gray-900">{status?.days_served ?? 0}</span>
          </div>
          <div className="flex items-center justify-between rounded-lg border border-gray-100 bg-gray-50 px-4 py-3">
            <span className="text-sm text-gray-600">Required days</span>
            <span className="font-medium text-gray-900">{status?.required_days ?? 0}</span>
          </div>
          <div className="flex items-center justify-between rounded-lg border border-gray-100 bg-gray-50 px-4 py-3">
            <span className="text-sm text-gray-600">Remaining days</span>
            <span className="font-medium text-gray-900">{status?.remaining_days ?? 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyIncrement;
